<template>
  <v-btn
    block
    class="font-weight-black"
    :class="{
      'py-8': !medium,
      'py-7': medium,
      'not-allowed': loading,
      'white--text': !dark
    }"
    x-large
    :color="dark ? 'white' : ''"
    :outlined="outlined"
    elevation="none"
    @click="click()"
  >
    <span v-if="dark">
      <span v-if="!loading" class="font-weight-bolder">{{ text }}</span>
      <v-progress-circular v-else indeterminate :color="dark ? 'accent' : 'white'" />
    </span>
    <div v-else class="wrapper" :class="{ 'not-allowed': disabled }">
      <div>
        <v-progress-circular v-if="loading" indeterminate color="white" />
        <span v-else class="font-weight-bolder">{{ text }}</span>
      </div>
      <img src="@/assets/BG_IMAGE.png" :style="disabled ? 'opacity: 0.6;' : ''">
    </div>
  </v-btn>
</template>

<script>
export default {
  props: {
    text: String,
    medium: Boolean,
    disabled: Boolean,
    outlined: Boolean,
    loading: Boolean,
    dark: Boolean,
    on: Object
  },
  methods: {
    click () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  border-radius: 10px;
  overflow: hidden;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.not-allowed {
  cursor: not-allowed;
  & img, div, span {
    cursor: not-allowed;
  }
}
.wrapper {
  min-height: 180px;
  max-height: 180px;
  width: 100%;
  cursor: pointer;
  border-radius: 6px;
  max-width: 600px;
  position: relative;
  align-content: center;
  & img {
    min-height: inherit;
    position: absolute;
    top: -3%;
    left: 44%;
    transform: translate(-50%, -50%);
    @media (min-width: 1700px) {
      left: 50%;
    }
  }
  & div {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 10px;
    z-index: 1;
  }
}
::v-deep {
  .v-btn__content {
    font-size: 20px !important;
  }
}
</style>
